import { TacticsAndTechniquesController } from '../controller/TacticsAndTechniquesController';
import { BaseWebComponentElement } from '../../../framework/BaseWebComponentElement';
import { MitreTags } from '../types';

export class TacticsAndTechniquesWebComponent extends BaseWebComponentElement {
  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: TacticsAndTechniquesController,
    });
  }
  get mitreTags(): MitreTags {
    const value = this.getAttribute('data-mitre-tags');
    return value ? JSON.parse(value) : {};
  }

  set mitreTags(value: MitreTags) {
    if (!value) {
      return;
    }
    this.setAttribute('data-mitre-tags', JSON.stringify(value));
  }
}
